import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from "react-icons/fa";


const ContactUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    country_code: "+91",
    phone_number: "",
    subject: "",
    message: "",
  });

  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const showPopup = (type, message) => {
    setPopup({ show: true, type, message });
    setTimeout(() => {
      setPopup({ show: false, type: "", message: "" });
    }, 5000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://growthloomdigital.com/api/contactform.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (res.ok && data.status) {
        showPopup("success", "Message sent successfully!");
        setFormData({
          full_name: "",
          email: "",
          country_code: "+91",
          phone_number: "",
          subject: "",
          message: "",
        });
      } else {
        showPopup("error", data.message || "Failed to send message.");
      }
    } catch (err) {
      console.error(err);
      showPopup("error", "An error occurred. Try again later.");
    }
  };

  return (
    <section className="w-full bg-[#f5f7fb] py-16 px-4 sm:px-6 lg:px-12 2xl:px-32 mt-[5%]">
      <div className="max-w-screen-2xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-12" data-aos="fade-down">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800">
            Contact <span className="text-[#f99728]">Us</span>
          </h2>
          <p className="text-gray-500 mt-3 text-sm sm:text-base">
            Get in touch with our HR experts for your business needs
          </p>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">

          {/* LEFT SIDE */}
          <div className="space-y-6">

            {/* Head Office */}
            <div
              data-aos="fade-up"
              className="bg-white p-6 rounded-2xl border border-gray-200 
              shadow-md hover:shadow-2xl 
              hover:border-blue-400 
              transform hover:-translate-y-2 
              transition-all duration-500"
            >
              <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                📍 Location
              </h3>
              <p className="text-gray-500 text-sm mt-2">
                Building No. 849,<br/> Vasundhara Sector 13,<br/> Ghaziabad, Uttar Pradesh, 201012.
              </p>
              {/* <p className="text-blue-500 mt-3 text-sm font-medium">
                📞 +91-9998881110
              </p> */}
            </div>

            {/* Branch Office */}
            <div
              data-aos="fade-up"
              data-aos-delay="150"
              className="bg-white p-6 rounded-2xl border border-gray-200 
              shadow-md hover:shadow-2xl 
              hover:border-blue-400 
              transform hover:-translate-y-2 
              transition-all duration-500"
            >
              <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                📞 Info
              </h3>
              <p className="text-gray-500 text-sm mt-2">
                <FaEnvelope className="text-[#f99728]" /> info@growthloomdigital.com<br/>
                <FaEnvelope className="text-[#f99728]" /> sales@growthloomdigital.com
              </p>
              <p className="text-[#f99728] mt-3 text-sm font-medium">
                📞 +91-9988776650
              </p>
            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div
            data-aos="fade-left"
            className="bg-white p-6 sm:p-8 rounded-2xl border border-gray-200 
            shadow-lg hover:shadow-2xl 
            hover:border-blue-400 
            transition-all duration-500"
          >
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 sm:grid-cols-2 gap-4"
            >

              {/* Full Name */}
              <input
                type="text"
                name="full_name"
                placeholder="Full Name"
                value={formData.full_name}
                onChange={handleChange}
                className="px-4 py-3 border border-gray-300 rounded-lg outline-none 
                focus:ring-2 focus:ring-blue-400 focus:border-blue-400 
                hover:border-blue-300 transition duration-300 w-full"
                required
              />

              {/* Email */}
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                className="px-4 py-3 border border-gray-300 rounded-lg outline-none 
                focus:ring-2 focus:ring-blue-400 focus:border-blue-400 
                hover:border-blue-300 transition duration-300 w-full"
                required
              />

              {/* Phone */}
              <input
                type="tel"
                name="phone_number"
                placeholder="Phone Number"
                value={formData.phone_number}
                onChange={handleChange}
                className="px-4 py-3 border border-gray-300 rounded-lg outline-none 
                focus:ring-2 focus:ring-blue-400 focus:border-blue-400 
                hover:border-blue-300 transition duration-300 w-full"
                required
              />

              {/* Subject */}
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                className="px-4 py-3 border border-gray-300 rounded-lg outline-none 
                focus:ring-2 focus:ring-blue-400 focus:border-blue-400 
                hover:border-blue-300 transition duration-300 w-full"
                required
              />

              {/* Message */}
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                className="sm:col-span-2 px-4 py-3 border border-gray-300 rounded-lg outline-none 
                focus:ring-2 focus:ring-blue-400 focus:border-blue-400 
                hover:border-blue-300 transition duration-300 w-full resize-none"
                required
              />

              {/* Button */}
              <div className="sm:col-span-2">
                <button
                  type="submit"
                  className="w-full py-3 rounded-full text-white font-medium 
                  bg-[#f99728] hover:to-blue-800 
                  hover:scale-105 
                  shadow-md hover:shadow-xl 
                  transition-all duration-300"
                >
                  Send Message
                </button>
              </div>

            </form>
          </div>
        </div>

        {/* Floating Icons */}
        {/* <div className="fixed right-4 bottom-20 flex flex-col gap-3 z-50">

          <a href="#"
            className="bg-green-500 p-3 rounded-full shadow-lg text-white 
            hover:scale-110 hover:shadow-2xl transition duration-300">
            💬
          </a>

          <a href="#"
            className="bg-orange-500 p-3 rounded-full shadow-lg text-white 
            hover:scale-110 hover:shadow-2xl transition duration-300">
            ✉️
          </a>

          <a href="#"
            className="bg-blue-500 p-3 rounded-full shadow-lg text-white 
            hover:scale-110 hover:shadow-2xl transition duration-300">
            📞
          </a>

        </div> */}
      </div>

      {/* Popup */}
      {popup.show && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div
            className={`p-6 rounded-xl text-white ${
              popup.type === "success" ? "bg-green-500" : "bg-red-500"
            }`}
          >
            <h3 className="font-bold text-lg mb-2">
              {popup.type === "success" ? "Success" : "Error"}
            </h3>
            <p>{popup.message}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactUs;